/**
 * @generated SignedSource<<382e0ecdec653e44b7c2cbade0d6e30d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type BuyerLocalPickup_localPickupQuote$data = {
  readonly serviceId: string | null;
  readonly " $fragmentType": "BuyerLocalPickup_localPickupQuote";
};
export type BuyerLocalPickup_localPickupQuote$key = {
  readonly " $data"?: BuyerLocalPickup_localPickupQuote$data;
  readonly " $fragmentSpreads": FragmentRefs<"BuyerLocalPickup_localPickupQuote">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "BuyerLocalPickup_localPickupQuote",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "serviceId",
      "storageKey": null
    }
  ],
  "type": "ShipmentQuote",
  "abstractKey": null
};

(node as any).hash = "e5d122a00df99c2a1d3e1df7af08c060";

export default node;
